var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "space",
    clipPath: "url(#clip0_2923_546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "space_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "space_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.8025 24.05C38.8025 24.7511 38.524 25.4236 38.0282 25.9194C37.5324 26.4152 36.8599 26.6937 36.1587 26.6937C35.4576 26.6937 34.7851 26.4152 34.2893 25.9194C33.7935 25.4236 33.515 24.7511 33.515 24.05C33.515 23.3489 33.7935 22.6764 34.2893 22.1806C34.7851 21.6848 35.4576 21.4063 36.1587 21.4063C36.8599 21.4063 37.5324 21.6848 38.0282 22.1806C38.524 22.6764 38.8025 23.3489 38.8025 24.05ZM60 30C60 46.5675 46.5675 60 30 60C29.125 60 28.2575 59.9625 27.4 59.89C32.4475 55.165 33.77 47.2375 33.77 47.2375L25.705 44.605C25.705 44.605 21.9575 52.68 11.7075 53.78C8.0622 50.9804 5.11012 47.3793 3.07993 43.2556C1.04974 39.1319 -0.00410214 34.5963 1.19998e-05 30C1.19998e-05 13.4325 13.4325 0 30 0C46.5675 0 60 13.4325 60 30ZM21.57 16.515C18.495 16.19 16.8575 14.44 16.495 11.4375C16.14 14.335 14.57 16.1375 11.415 16.515C14.335 17.0825 15.99 18.81 16.4925 21.595C16.4425 18.71 18.1575 17.0325 21.57 16.515ZM41.035 29.5325C43.81 23.325 42.015 18.9025 37.9525 13.9175C32.845 17.6675 28.555 21.475 28.8625 26.79C25.425 28.4775 23.21 29.805 20.995 32.5125L27.9425 35.27L27.0225 38.4375L36.115 41.0925L37.2225 38.14L44.285 39.7675C44.32 36.0275 43.335 32.025 41.035 29.5325Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "animi"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.5594 15.6636L18.0746 14.6287L16.9522 11.1712C16.9216 11.0765 16.8605 10.9946 16.7784 10.9383C16.5728 10.7967 16.2903 10.8487 16.1474 11.0542L14.087 14.0491L10.4519 14.049C10.3517 14.0488 10.2552 14.082 10.1763 14.1421C10.0809 14.2154 10.0184 14.3236 10.0027 14.4429C9.98692 14.5623 10.0192 14.6829 10.0924 14.7785L12.3031 17.6641L11.1791 21.1215C11.1528 21.202 11.1496 21.2881 11.1699 21.3703C11.1901 21.4524 11.2329 21.5272 11.2935 21.5863C11.3541 21.6453 11.43 21.6862 11.5126 21.7043C11.5952 21.7224 11.6813 21.7169 11.761 21.6886L15.1885 20.4774L18.1294 22.6143C18.2096 22.6732 18.3083 22.7033 18.4075 22.7006C18.6576 22.694 18.8552 22.4865 18.8486 22.2364L18.7556 18.602L21.6963 16.4652C21.7763 16.4067 21.8357 16.3237 21.8639 16.2276C21.9375 15.9877 21.7994 15.7357 21.5594 15.6636Z",
    fill: "#1A1A1A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2923_546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpace);
export default __webpack_public_path__ + "static/media/space.cd0d39c2ddec10807a35bdc879e1d831.svg";
export { ForwardRef as ReactComponent };